"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var public_api_1 = require("@l2p/public-api");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useCalculatedBonuses = function (data, currentCurrency) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var bonuses = data === null || data === void 0 ? void 0 : data.map(function (bonus) {
        var _a, _b, _c, _d;
        var maxBonusData = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.constraints) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === public_api_1.BonusConstraintType.MaxBonus; });
        var maxBonus = (_b = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _b === void 0 ? void 0 : _b.find(function (b) { return b.currency === currentCurrency; });
        var maxBonusAmount = maxBonus === null || maxBonus === void 0 ? void 0 : maxBonus.amount;
        var minDepositData = (_c = bonus === null || bonus === void 0 ? void 0 : bonus.conditions) === null || _c === void 0 ? void 0 : _c.find(function (c) { return c.type === public_api_1.BonusConditionType.MinDepositAmount; });
        var minDeposit = (_d = minDepositData === null || minDepositData === void 0 ? void 0 : minDepositData.minDeposit) === null || _d === void 0 ? void 0 : _d.find(function (d) { return d.currency === currentCurrency; });
        return __assign(__assign({}, bonus), { minDeposit: minDeposit === null || minDeposit === void 0 ? void 0 : minDeposit.amount });
    });
    return (0, react_1.useMemo)(function () {
        return bonuses;
    }, [bonuses]);
};
exports.default = useCalculatedBonuses;
